<template>
  <el-card class="quotes-list-resume"
           shadow="never">
    <el-row type="flex">
      <el-col>
        <strong>{{ value.pickup.address.locality }}</strong>
        <br>
        {{ value.pickup.address.regionName }}
      </el-col>
      <el-col>
        <i class="el-icon-right"></i>
      </el-col>
      <el-col>
        <strong>{{ value.delivery.address.locality }}</strong>
        <br>
        {{ value.delivery.address.regionName }}
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col>
        <el-tag effect="dark"
                size="mini"
                type="info">
          {{ $t(`QUOTES_LIST_RESUME.PACKAGING_TYPE.${value.packagingType}`) }}
          &nbsp;/&nbsp;
          {{ $t(`QUOTES_LIST_RESUME.EQUIPMENT_TYPE.${value.equipmentType}`) }}
          &nbsp;/&nbsp;
          {{ value.weight | number('TON', 'LB') }}
          <span v-if="value.distance">
            &nbsp;/&nbsp;
            {{ value.distance | number('M', 'MI') }}
          </span>
        </el-tag>
      </el-col>
      <el-col :lg="8"
              :md="8"
              class="hidden-sm-and-down">
        <el-row type="flex">
          <el-col>
            <app-state-alert :value="value.state">
            </app-state-alert>
          </el-col>
          <el-col>
            <el-badge :hidden="value.numberOfResponses === 0"
                      :value="value.numberOfResponses"
                      type="primary">
              <el-tag effect="dark"
                      size="mini"
                      type="info"
                      v-if="value.expectedAmount">
                {{ value.expectedAmount | currency({ currency: value.currency,
                minimumFractionDigits: 0 }) }}
              </el-tag>
            </el-badge>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="hidden-md-and-up"
            type="flex">
      <el-col>
        <app-state-alert :value="value.state">
        </app-state-alert>
      </el-col>
      <el-col>
        <el-badge :hidden="value.numberOfResponses === 0"
                  :value="value.numberOfResponses"
                  type="primary">
          <el-tag effect="dark"
                  size="mini"
                  type="info"
                  v-if="value.expectedAmount">
            {{ value.expectedAmount | currency({ currency: value.currency, minimumFractionDigits: 0
            }) }}
          </el-tag>
        </el-badge>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import AppStateAlert from '@/components/state-alert/StateAlert'

export default {
  name: 'QuotesListResume',
  components: { AppStateAlert },
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.quotes-list-resume {
  &:hover,
  &:active {
    background-color: #EBEEF5;
    cursor: pointer;
  }

  .el-row + .el-row {
    margin-top: 0.5rem;
  }

  .el-row:first-child {
    .el-col:nth-child(2) {
      text-align: center;
    }

    .el-col:last-child {
      text-align: right;
    }
  }

  .el-row:last-child {
    .el-col:last-child {
      text-align: right;
    }
  }
}
</style>
